import LoginCreators from "../pages/loginPage/duck/actions";

class UnauthorizedError extends Error {
	constructor(dispatch) {
		super("Unauthorized Error");
		dispatch(LoginCreators.logoutUser());
	}
}

export default UnauthorizedError;